import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {FileSaverService} from "ngx-filesaver";
import {PrivacyManagerEndpoints} from "./privacy-manager-endpoints";
import {CommonEndpoints} from "./common-endpoints";
import {ClientEndpoints} from "./client-endpoints";
import {DocumentsEndpoints} from "./documents-endpoints";
import {SalesEndpoints} from "./sales-endpoints";
import {ReviewEndpoints} from "./review-endpoints";
import {UserEndpoints} from "./user-endpoints";
import {AppSettingEndpoints} from "./app-setting-endpoints";
import {AssetsEndpoints} from "./assets-endpoints";

@Injectable({providedIn: "root"})
export class EndpointsProvider {

	readonly client: ClientEndpoints;
	readonly documents: DocumentsEndpoints;
	readonly sales: SalesEndpoints;
	readonly review: ReviewEndpoints;
	readonly user: UserEndpoints;
	readonly appSettings: AppSettingEndpoints;
	readonly common: CommonEndpoints;
	readonly assets: AssetsEndpoints;
	readonly privacyManager: PrivacyManagerEndpoints;

	constructor(http: HttpClient, fileSaver: FileSaverService) {
		this.client = new ClientEndpoints(http)
		this.documents = new DocumentsEndpoints(http, fileSaver)
		this.sales = new SalesEndpoints(http)
		this.review = new ReviewEndpoints(http)
		this.user = new UserEndpoints(http)
		this.appSettings = new AppSettingEndpoints(http)
		this.common = new CommonEndpoints(http)
		this.assets = new AssetsEndpoints(http)
		this.privacyManager = new PrivacyManagerEndpoints(http)
	}
}

